// employees/state.js

export const employeesInitialState = {
  list: [],
  // This is the list of all employees in the database, including inactive ones.
  terminatedList: [],
  loading: false,
  error: null,
};
